import React, { Component } from 'react';
import cn from 'classnames';
import styles from './Features.scss';

import iconUpdate from 'assets/images/icons/update-arrows.svg';
import { updateString } from 'utils';

import * as featureIcons from 'assets/images/features';

import getFeatures from 'constants/Features';
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';

const eps = 10;

class Features extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isHidden: true,
    };

    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  componentDidMount() {
    this.handleTrackEvent({ eventName: 'buildingInfoBlocksShow', eventLabel: 'preimushchestva' });
  }

  handleButtonClick() {
    const { isHidden } = this.state;
    this.handleTrackEvent({
      eventName: 'buildingInfoBlocksExpand',
      eventLabel: isHidden ? 'podrobnee' : 'svernut',
      eventContent: 'preimushchestva',
    });
    this.setState({ isHidden: !isHidden });
  }

  getRef = (ref) => {
    this.ref = ref;
    if (this.ref) {
      setTimeout(this.checkIfTruncated, 500);
    }
  };

  checkIfTruncated = () => {
    if (this.ref && this.ref.scrollHeight - eps > this.ref.clientHeight) {
      this.setState({
        truncated: true,
      });
    }
  };

  handleTrackEvent = ({ eventName, eventLabel, eventContent }) => {
    const { building, objectType, profile } = this.props;
    const { title, id } = building.data;

    trackGA(
      gaEvent[eventName]({
        eventLabel,
        eventContent,
        productType: objectType,
        productName: title,
        productID: id,
        user_id: profile.id,
      })
    );
  };

  render() {
    const { building, client, print, t } = this.props;
    const { data } = building;
    const { isHidden } = this.state;
    const { update } = building.data || {};
    let updateTime;
    if (update) {
      if (updateString(update).indexOf('Сегодня') == 0) {
        updateTime = t('components.building.main.features.today');
      } else {
        updateTime = updateString(update);
      }
    }

    const features = getFeatures(t);

    const list = Object.keys(data.additional)
      .filter((item) =>
        ['black_list', 'new', 'nedvex'].includes(item) ? null : data.additional[item]
      )
      .map((item, i) => (
        <div className={styles.CheckItem} key={i}>
          {print ? (
            `${features[item]}, `
          ) : (
            <div className={styles.CheckItemInner}>
              <div className={styles.Image}>
                <img alt="icon" src={featureIcons[item]} />
              </div>
              <div className={styles.Text}>{features[item]}</div>
            </div>
          )}
        </div>
      ));

    return list.length ? (
      <div
        className={cn(
          styles.FeaturesWrap,
          { [styles.FeaturesWrapClient]: client },
          { [styles.FeaturesWrapPrint]: print }
        )}
      >
        <div className={cn(styles.FeaturesTitle)}>
          {t('components.building.main.features.advantages')}
          {client ? (
            <div
              className={styles.UpdatedTime}
              data-tip={t('components.building.main.features.date')}
              data-for="global"
            >
              <img alt="icon" src={iconUpdate} />
              <span>
                <span>{t('components.building.main.features.updated')} </span>
                {` ${updateTime}`}
              </span>
            </div>
          ) : null}
        </div>
        <div className={styles.CheckBlockWrap}>
          <div
            className={cn(client ? styles.CheckBlock : styles.CheckBlock, this.props.className, {
              [styles.isHidden]: isHidden,
            })}
            ref={this.getRef}
          >
            {list}
          </div>
          {this.state.truncated && (
            <div className={styles.ButtonMore} onClick={this.handleButtonClick}>
              <span>
                {isHidden
                  ? t('components.building.main.features.showAll')
                  : t('components.building.main.features.minimize')}{' '}
                <i className={isHidden ? null : styles.Opened}></i>
              </span>
            </div>
          )}
        </div>
      </div>
    ) : null;
  }
}

export default withTranslation()(Features);



// WEBPACK FOOTER //
// ./src/components/Building/Main/Features/Features.js